function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

export var EventHandler = function () {
  function EventHandler() {
    _classCallCheck(this, EventHandler);

    this.callbacks = [];
  }
  /**
   * Register a callback function.
   *
   * @param callback
   * @returns {Function} unregister function
   */


  EventHandler.prototype.register = function register(callback) {
    var _this = this;

    this.callbacks.push(callback);
    return function () {
      _this.callbacks = _this.callbacks.filter(function (item) {
        return item !== callback;
      });
    };
  };

  /**
   * Trigger all registered callback functions. Arguments provided
   * to trigger are passed to the callbacks.
   */


  EventHandler.prototype.trigger = function trigger() {
    var _this2 = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this.callbacks.forEach(function (callback) {
      callback.apply(_this2, args);
    });
  };

  /**
   * Remove all registered callbacks.
   */


  EventHandler.prototype.destroy = function destroy() {
    this.callbacks.length = 0;
  };

  return EventHandler;
}();